import { ReadingTaskDetailRow, ReadingTaskRow } from './types';
import {
  CheckMarkIcon,
  CloseNewIcon,
  ProcessNewIcon,
} from '@dynamika-shared/ui/icons';

export const isDetail = (row: ReadingTaskRow): row is ReadingTaskDetailRow =>
  row.type === 'detail';

export const getStatusIcon = (status?: string) => {
  switch (status) {
    case 'COMPLETED':
      return CheckMarkIcon;
    case 'FAILED':
      return CloseNewIcon;
    case 'IN_PROGRESS':
    default:
      return ProcessNewIcon;
  }
};
